import React, { Component } from "react";
import {
  Grid,
  Divider,
  Card,
  CardContent,
  Typography,
  IconButton,
  CardActions,
  CardHeader,
  CardMedia,
  Box,
} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReportIcon from "@mui/icons-material/Report";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AddIcon from "@mui/icons-material/Add"; // Plus icon
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DescriptionIcon from "@mui/icons-material/Description";
import BookIcon from "@mui/icons-material/Book";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { withRouter } from "../HOC/withRouter";
import CtCmb from "./CustomTool/CtCmb";
import moment from "moment";
import income from "../images/income.png";
import expenses from "../images/expenses .png";
import sale from "../images/sale.png";
import {
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCReduxData from "../HOC/HOCReduxData";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { connect } from "react-redux";
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Receipt } from "@mui/icons-material";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PaymentIcon from '@mui/icons-material/Payment';

class Dashboard3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: "", // Initialize state to track selected value
            date: [
                { name: "Today" },
                { name: "This Month" },
                { name: "From Date - To Date" },
            ],
data: [
  {
    id: 1,
    tcolor: "#6e5858",
    color: "#dddddd",
        underlineColor: "#7ec6fc",

    title: "Sales",
        //  amount: " ₹ 3,766",
    amount: (
    <Typography  variant="h3" sx={{ color: "#007BFF", fontWeight: "bold" }}> ₹ 3,766</Typography> // Apply tcolor to amount
  ),
    subtitle: "Total Sales Today: 250",
    icon: (
    //   <CardMedia
    //     component="img"
    //     alt="Sale icon"
    //     sx={{
    //       width: 55,
    //       filter: "invert(24%) sepia(53%) saturate(686%) hue-rotate(317deg) brightness(85%) contrast(98%)",
    //       color: "#007BFF", // Apply tcolor to icon
    //     }}
    //     image={sale}
    //   />    icon: (
      <CurrencyRupeeIcon sx={{ fontSize: 55, color: "#6e5858" }} /> // Apply tcolor to icon
    ),
    route: "/SalesList",
    route1: "/Salesentry",
    t: "Sales List",
    t1: "Sales Entry",
    Today: " ₹ 3,766",
    ThisMonth: " ₹ 12,342",
    FromDateToDate: " ₹ 8,145",
    dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
    dtpToDate: moment().format("DD-MM-YYYY"),
  },
  {
    id: 2,
    // tcolor: "#28A745",
    tcolor: "#6e5858",
            underlineColor: "#28A745",

    color: "#dddddd",
    title: "Purchase",
      //  amount: " ₹ 652",
    amount: (
    <Typography  variant="h3" sx={{ color: "#007BFF", fontWeight: "bold" }}> ₹  652 </Typography> // Apply tcolor to amount
  ),
    subtitle: "Total Purchase Today: 40",
    icon: (
      <ShoppingCartIcon sx={{ fontSize: 55, color: "#6e5858" }} /> // Apply tcolor to icon
    ),
    route: "/PurchaseList",
    route1: "/PurchaseEntry",
    t: "Purchase List",
    t1: "Purchase Entry",
    Today: " ₹ 652",
    ThisMonth: " ₹ 2,124",
    FromDateToDate: " ₹ 1,780",
    dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
    dtpToDate: moment().format("DD-MM-YYYY"),
  },
  {
    id: 3,
    // tcolor: "#FF0000",
    tcolor: "#6e5858",
                underlineColor: "#FF0000",

    color: "#dddddd",
    title: "Receipt",
      // amount: " ₹ 21,156",
    amount: (
    <Typography  variant="h3" sx={{ color: "#007BFF", fontWeight: "bold" }}> ₹ 21,156</Typography> // Apply tcolor to amount
  ),
    subtitle: "Total Receipt Today: 310",
    icon: (
    //   <CardMedia
    //     component="img"
    //     alt="Receipt icon"
    //     sx={{
    //       width: 55,
    //       filter: "invert(24%) sepia(53%) saturate(686%) hue-rotate(317deg) brightness(85%) contrast(98%)",
    //       color: "#FF0000", // Apply tcolor to icon
    //     }}
    //     image={income}
        //   />
              <Receipt sx={{ fontSize: 55, color: "#6e5858" }} /> // Apply tcolor to icon
    ),
    route: "/ReceiptList",
    route1: "/ReceiptEntry",
    t: "Receipt List",
    t1: "Receipt Entry",
    Today: " ₹ 21,156",
    ThisMonth: " ₹ 45,876",
    FromDateToDate: " ₹ 39,213",
    dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
    dtpToDate: moment().format("DD-MM-YYYY"),
  },
  {
    id: 4,
  //  tcolor: "#FFC107",
    tcolor: "#6e5858",
          underlineColor: "#FFC107",

          
    color: "#dddddd",
    title: "Payment",
      // amount: " ₹ 38",
    amount: (
    <Typography  variant="h3" sx={{ color: "#007BFF", fontWeight: "bold" }}> ₹ 38 </Typography> // Apply tcolor to amount
  ),
    subtitle: "Total Payment Today: 2",
    icon: (
    //   <CardMedia
    //     component="img"
    //     alt="Payment icon"
    //     sx={{
    //       width: 55,
    //       filter: "invert(24%) sepia(53%) saturate(686%) hue-rotate(317deg) brightness(85%) contrast(98%)",
    //       color: "#FFC107", // Apply tcolor to icon
        //     }}
        // image={expenses}
        // />
    <PaymentIcon sx={{ fontSize: 55, color: "#6e5858" }} /> // Apply tcolor to icon

    ),
    route: "/PaymentList",
    route1: "/PaymentEntry",
    t: "Payment List",
    t1: "Payment Entry",
    Today: " ₹ 38",
    ThisMonth: " ₹ 1,024",
    FromDateToDate: " ₹ 852",
    dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
    dtpToDate: moment().format("DD-MM-YYYY"),
  },
],
        };
    }
    
    handleComboBoxChange = (e, id) => {
        this.setState({ selectedValue: e.target.value }); // Update selected value on change
        this.handleOnChange(e, id); // Assuming you still want to handle the change as you did earlier
    };


    handleNavigate = (route) => {
        this.props.navigate(route);
    };

    handleOnChange = (e, id) => {
        const { value } = e.target;
        this.setState((prevState) => ({
            data: prevState.data.map((item) =>
                item.id === id ? { ...item, txtdate: value } : item
            ),
        }));
    };

    calculateSubtitle = (item) => {
        const currentDate = item.txtdate || this.state.txtdate;
        switch (currentDate) {
            case "Today":
                return `${item.Today}`;
            case "This Month":
                return `${item.ThisMonth}`;
            case "From Date - To Date":
                return `${item.dtpFromDate} To ${item.dtpToDate}: ${item.FromDateToDate}`;
            default:
                return "";
        }
    };

    render() {
        const { date } = this.state;
        const { selectedValue, showCalendar } = this.state; // Manage calendar visibility in state

        const boxHeight = selectedValue === "SomeValue" ? '10px' : '10px'; // Example condition

        return (
            <Grid container  padding={2} >
                <Grid item xs={12} >
                    <Grid container justifyContent="space-between" spacing={2} >
                        {this.state.data.map((item) => (
                            <Grid item xs={12} sm={6} md={3} lg={3} key={item.id}>
                                <Card
                                    sx={{
                                        backgroundColor: item.color,
                                        color: "black",
                                        height: "300px",
                                        position: "relative",
                                        transition: "transform 0.3s ease-in-out",
                                        "&:hover": {
                                            transform: "scale(1.05)",
                                        },
                                    }}
                                >
<CardHeader
  avatar={
<div
  style={{
    display: "flex",
    flexDirection: "row",  // Stacks title/icons and underline in a column
    alignItems: "flex-start",    // Center align everything horizontally
    width: "90%",           // Full width of the parent container
    position: "absolute",
  }}
>
 
    <div style={{  gap:"300px" }}>
      <Typography
        variant="h5"
        style={{
          color: item.tcolor,
          fontWeight: "700",
          letterSpacing: 2,
          marginBottom: "3px",
        }}
      >
        {item.title}
      </Typography>
    </div>

    {/* Icons Container */}
    <div style={{ gap: "150px" , textAlign : "right " , flexGrow: 3}}> {/* Space only between icons */}
      <IconButton
        style={{
          cursor: "pointer",
          transition: "transform 0.3s ease-in-out",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
        onClick={() => this.handleNavigate(item.route)}
        title={item.t}
      >
        <ArticleIcon style={{ color: item.tcolor }} />
      </IconButton>

      <IconButton
        style={{
          cursor: "pointer",
          transition: "transform 0.3s ease-in-out",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = "scale(1.1)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
        onClick={() => this.handleNavigate(item.route1)}
        title={item.t1}
      >
        <AddCircleIcon style={{ color: item.tcolor }} />
      </IconButton>
    </div>

  {/* Full-width Underline - Responsive */}
  <div
    style={{
      position: "absolute",
      bottom: "-5px",
      left: "0",
      width: "150%",
      height: "4px",
      backgroundColor: item.underlineColor,
      borderRadius: "2px",
      marginTop : "10px",
    }}
  />
</div>

  }
/>
                                 
<CardContent>
  {/* Row containing Amount and Icon side by side */}
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between', // Items side by side
      alignItems: 'center', // Align items vertically in the center
      marginBottom: '16px', // Adjust margin as needed
      marginTop: '36px',
    }}
  >
    {/* Amount Text */}
    <Typography
      variant="h4"
      sx={{ fontWeight: 'bold', color: '#602537' }}
    >
      {item.amount}
    </Typography>

    {/* Icon */}
    <div>
      {item.icon}
    </div>
  </div>

<div>   
    <CtCmb
      id={`date-${item.id}`}
      label=""
      items={date}
      style={{
        marginTop: '18px', // Space between CtCmb and other content below
        }}
      value={item.txtdate}
      handleOnChange={(e) => this.handleOnChange(e, item.id)}
      colID="name"
      width={200}
/>
</div>
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: "9px",
        }}></div>

    <div
        style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
            padding: "16px",
            borderRadius: "4px",
            width: "100%",
            boxSizing: "border-box",
        }}
    >

                           
        <Divider
            orientation="vertical"
            sx={{
                height: "35px",
                width: "4px",
                backgroundColor: "#dddddd",
                marginRight: "16px",
            }}
        />
        
<div style={{
      fontWeight: "bold",
    color: "#602537", // Set your desired color
    textShadow: '0 0 8px rgba(255, 255, 255, 0.8), 0 0 16px rgba(255, 255, 255, 0.6), 0 0 24px rgba(255, 255, 255, 0.4)', // Glowing effect
  
    flex: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: '1.0rem', // Adjust font size
}}> 
      {this.calculateSubtitle(item)}
    </div> </div>
    

    {/* Subtitle with glowing effect */}
    {/* <div
      style={{
        fontWeight: 'bold',
        color: '#602537',
        textShadow:
          '0 0 8px rgba(255, 255, 255, 0.8), 0 0 16px rgba(255, 255, 255, 0.6), 0 0 24px rgba(255, 255, 255, 0.4)', // Glowing effect
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '1.5rem', // Adjusted font size for better visibility
        flex: 1,
        padding: '8px', // Add padding for better appearance
        backgroundColor: 'white', // Ensure the background is white
        borderRadius: '4px', // Rounded corners
        width: '100%',
        // Ensure it takes full width
    }}
                                            />
                                                <Divider
      orientation="horizontal"
      sx={{
        height: '4px',
        backgroundColor: '#dddddd',
        marginBottom: '16px', // Space between the divider and content
      }}
    /> */}
                                            
 
        
</CardContent>        
                                </Card>
                            {/* Display calendar popup if showCalendar is true */}
                            
                                     </Grid>
                                 ))}
                             </Grid>
                         </Grid>
                     </Grid>
                 );
             }
         }
         export default withRouter(
           connect(
             mapStatetoProps,
             mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps
           )(HOCVerifyIsUser(HOCReduxData(HoCtToastContainer(Dashboard3))))
         );
         